import React from 'react';
import { Heading } from '@klp/design/Heading';
import { useProsjektSammendragContext } from './context/ProsjektSammendragProvider';

export const ProsjektSammendragTitle: React.FC = () => {
    const { currentProcess } = useProsjektSammendragContext();

    return (
        <Heading
            klpHeadingLevel="ONE"
            klpColor="dark"
            translation="prosjekt.summary.title"
            translationOptions={{ prosjektNavn: currentProcess?.navn }}
            data-testid="ProsjektSammendrag__Title"
        />
    );
};
